import { render, staticRenderFns } from "./RedemptionReviewDialog.vue?vue&type=template&id=0159d17c"
import script from "./RedemptionReviewDialog.vue?vue&type=script&lang=js"
export * from "./RedemptionReviewDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports